import { ActiveFilter } from '@epicuro-next/models/filters';

export const filtersToRequestFilters = (
  filters: ActiveFilter[],
): Record<string, string[]> =>
  filters.reduce(
    (acc, fItem) => ({
      ...acc,
      [fItem.id]: fItem.values,
    }),
    {},
  );
